import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<FuiSearch @settings={{hash onSelect=(changeset-set this.changeset this.key) source=@source searchDelay=@searchDelay}} @selected={{changeset-get this.changeset (concat this.key \".title\")}} />", {
  moduleName: "core/components/formy/search/index.hbs"
});